// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alignCenter {
    margin: 0 auto;
}
.availableTime {
    padding: 35px 0 0;
}
.answerOptions .custom-control-label {
    display: inline-block; 
    padding-left: 10px;
}
.availableTime .greenBtnBig {
    max-width: 100%;
    width: auto
}
.hiddenInput {
    opacity: 0;
    height: 0;
    padding: 0;
    border: none;
 
    z-index: 0;
    /* left: 45%;
    top: 90%; */
}

:host h3 strong {
  color: var(--color-purple);
}

.primary-button {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  cursor: pointer;
  padding: 16px 34px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-family: var(--font-main);
  font-size: 15px;
  line-height: 1;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--color-white);
  background: var(--color-green-button);
  transition: color var(--transition), background-color var(--transition), border-color var(--transition);
}

.primary-button:link,
.primary-button:visited {
  color: var(--color-white);
  text-decoration: none;
}

.primary-button:hover, 
.primary-button:focus-visible {
  color: var(--color-white);
  border-color: transparent;
  background: var(--color-purple);
}`, "",{"version":3,"sources":["webpack://./src/app/LSR/participant/participant_qualify/participant_qualify.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf;AACJ;AACA;IACI,UAAU;IACV,SAAS;IACT,UAAU;IACV,YAAY;;IAEZ,UAAU;IACV;eACW;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,qCAAqC;EACrC,uGAAuG;AACzG;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC","sourcesContent":[".alignCenter {\r\n    margin: 0 auto;\r\n}\r\n.availableTime {\r\n    padding: 35px 0 0;\r\n}\r\n.answerOptions .custom-control-label {\r\n    display: inline-block; \r\n    padding-left: 10px;\r\n}\r\n.availableTime .greenBtnBig {\r\n    max-width: 100%;\r\n    width: auto\r\n}\r\n.hiddenInput {\r\n    opacity: 0;\r\n    height: 0;\r\n    padding: 0;\r\n    border: none;\r\n \r\n    z-index: 0;\r\n    /* left: 45%;\r\n    top: 90%; */\r\n}\r\n\r\n:host h3 strong {\r\n  color: var(--color-purple);\r\n}\r\n\r\n.primary-button {\r\n  width: fit-content;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 48px;\r\n  cursor: pointer;\r\n  padding: 16px 34px;\r\n  border: 1px solid transparent;\r\n  border-radius: 999px;\r\n  font-family: var(--font-main);\r\n  font-size: 15px;\r\n  line-height: 1;\r\n  font-weight: 800;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n  text-decoration: none;\r\n  color: var(--color-white);\r\n  background: var(--color-green-button);\r\n  transition: color var(--transition), background-color var(--transition), border-color var(--transition);\r\n}\r\n\r\n.primary-button:link,\r\n.primary-button:visited {\r\n  color: var(--color-white);\r\n  text-decoration: none;\r\n}\r\n\r\n.primary-button:hover, \r\n.primary-button:focus-visible {\r\n  color: var(--color-white);\r\n  border-color: transparent;\r\n  background: var(--color-purple);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
